import { openDB } from 'idb';

const DB_NAME = 'myAppDB';
const DB_VERSION = 2;
const STORE_NAME = 'menuData';
const IMAGE_STORE_NAME = 'menuImages';

export const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' }); 
      }
      if (!db.objectStoreNames.contains(IMAGE_STORE_NAME)) {
        db.createObjectStore(IMAGE_STORE_NAME, { keyPath: 'id' }); // Almacén para imágenes
      }
    },
  });
};

export const saveData = async (key, value) => {
  try {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  tx.store.put({ id: key, value });
    await tx.done;
    } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.log('No se pudo almacenar el blob: límite de almacenamiento alcanzado.');
    } else {
      console.log('Error al almacenar el blob:', error);
    }
  }
};


export const saveImage = async (id, data) => {

  try {
    const db = await initDB();
    const tx = db.transaction(IMAGE_STORE_NAME, 'readwrite');
    tx.store.put({ id, data });
    await tx.done;
  } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.error('No se pudo almacenar el blob: límite de almacenamiento alcanzado.');
    } else {
      console.error('Error al almacenar el blob:', error);
    }
  }
};

export const getImage = async (id) => {
  const db = await initDB();
  return db.get(IMAGE_STORE_NAME, id);
};

export const getData = async (key) => {
  const db = await initDB();
  return db.get(STORE_NAME, key);
};

export const clearData = async () => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  tx.store.clear();
  await tx.done;
};

export const getMediaKeys = async () => {
  const db = await initDB();
  return db.getAllKeys(IMAGE_STORE_NAME);
};

export const deleteMedia = async (id) => {
  const db = await initDB();
  const tx = db.transaction(IMAGE_STORE_NAME, 'readwrite');
  tx.store.delete(id);
  await tx.done;
};
